<template>
    <NewSectionCard title="Your Booking Summary">
        <div class="space-y-4 bg-white">
            <dl>
                <dd class="text-sm text-brand-blue">Entry</dd>
                <dt class="text-lg">{{ formatTimestamp(booking.entry) }}</dt>
            </dl>
            <dl>
                <dd class="text-sm text-brand-blue">Exit</dd>
                <dt class="text-lg">{{ formatTimestamp(booking.exit) }}</dt>
            </dl>
            <dl>
                <dd class="text-sm text-brand-blue">Product</dd>
                <dt class="text-lg">{{ product.name }}</dt>
            </dl>

            <div v-for="(vehicle, index) in setVehicles" :key="vehicle.registration">
                <p class="text-lg font-bold mb-3">{{ vehicle.registration ?? 'Vehicle ' + (index + 1) }}</p>
                <dl class="ml-3">
                    <dd class="text-sm text-brand-blue">Parking Price</dd>
                    <dt class="text-lg">
                        <span v-if="vehicle?.type.original_adjusted" class="line-through text-red-500">{{ $filters.money(vehicle.type.original_adjusted) }} </span>
                        {{ $filters.money(vehicle?.type.original_adjusted ? vehicle.type.adjusted : vehicle.price) }}
                    </dt>
                </dl>
                <dl class="ml-3 mt-3" v-if="vehicle.valet?.price > 0">
                    <dd class="text-sm text-brand-blue">Total Valet Price</dd>
                    <dt class="text-lg"><span v-if="vehicle.valet?.original" class="line-through text-red-500">{{ $filters.money(vehicle.valet.original) }} </span> {{ $filters.money(vehicle.valet.price) }}</dt>
                </dl>
            </div>
            <dl>
                <dd class="text-sm text-brand-blue">Total</dd>
                <dt class="text-3xl font-semibold">{{ $filters.money(total) }}</dt>
            </dl>
        </div>
    </NewSectionCard>
</template>

<script>
export default {
    props: {
        booking: { required: true },
        carpark: { required: true },
        vehicles: { required: true, default: () => [{}] },
        product: { required: true },
    },
    methods: {
        formatTimestamp(timestamp) {
            const months = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ];

            const date = new Date(timestamp);
            const monthIndex = date.getMonth();
            const monthName = months[monthIndex];
            const hours = (`0${date.getHours()}`).slice(-2);
            const minutes = (`0${date.getMinutes()}`).slice(-2);

            return `${this.getNumberWithOrdinal(date.getDate())} ${monthName} ${date.getFullYear()} at ${hours}:${minutes}`;
        },
        getNumberWithOrdinal(n) {
            const s = ['th', 'st', 'nd', 'rd'];
            const v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        }
    },
    computed: {
        setVehicles() {
            return this.vehicles.filter((vehicle) => !!vehicle.type);
        },
        parkingPrice() {
            let total = 0;
            this.vehicles.filter((vehicle) => !!vehicle.type).forEach((vehicle) => {
                total += vehicle.type.original ? vehicle.type.adjusted : vehicle.price;
            });

            return total;
        },
        valetPrice() {
            let total = 0;
            this.vehicles.filter((vehicle) => !!vehicle.valet).forEach((vehicle) => { total += vehicle.valet.price; });

            return total;
        },
        total() {
            return this.parkingPrice + this.valetPrice;
        },
    },
    watch: {
        vehicles: {
            handler(newVal) {
                //console.log('Vehicles updated:', newVal);
            },
            deep: true,
        },
    },
    mounted() {
    },
};
</script>
